import { ref, watch } from 'vue'

import useRef from '@nicolaudie-group/ng-ui-kit/composables/useRef'

import useDebounceFn from '@/composables/useDebounceFn'

function cleanSearch(value) {
  return value.trim().toLowerCase()
}

function useDialogSearch(initial) {
  const searchQuery = useRef(initial)
  const searchInput = ref(searchQuery.value)
  const scrollAmount = ref(0)

  function clear() {
    // If the search string is cleared
    // Empty the string
    searchInput.value = ''
    // Scroll back to the top
    scrollAmount.value = 0
  }

  function scrolled(amount) {
    scrollAmount.value = amount
  }

  function search(cleaned) {
    // If the search string is cleared or long enough
    if (cleaned.length > 1 || cleaned === '') {
      // Update the search in the store
      searchQuery.value = cleaned
    }
  }

  const debouncedSearch = useDebounceFn(search, 200, 1000)

  watch(searchInput, (newValue) => {
    const cleaned = cleanSearch(newValue)
    if (cleaned) {
      // If there is a search string
      // Apply debounced search
      debouncedSearch(cleaned)
    } else {
      // If the search was cleared
      // Apply immediate search
      search(cleaned)
    }
  })

  return {
    searchInput,
    searchQuery,
    clear,
    scrolled,
    scrollAmount,
  }
}

export default useDialogSearch
